import { useEffect, useRef, useState } from "react";
import LoaderModal from "../../modals/common/LoaderModal";
import { isMobile, scroll2Top } from "../../utils/utils";
import useAppState from "../../context/AppContext";
import REGuarantyRetirementBloc from "../../blocs/retirement/REGuarantyRetirementBloc";
import useFetchRetiredGaranties from "../../hooks/useFetchRetiredGaranties";



export default function REGuarantyRetirementPage() {

  const {
    state: { updatedProposition },
  
  } = useAppState();

    const [displayedPage, setDisplayedPage] = useState<"INFO" | "INFO_TABLE" | "OFFER" | "COMPARE">("INFO");

    const pageGapRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
        if (isMobile()) {
        pageGapRef.current?.scrollIntoView() 
        } else {
        scroll2Top();
        }
        // if(updatedProposition?.offerCode) {
        //   setIsShowComparePage(false);
        // }
    }, [updatedProposition?.offerCode]);

    const { loading, garanties } = useFetchRetiredGaranties();

    const handleSwitchPage = (pageCode: "INFO" | "INFO_TABLE" | "OFFER" | "COMPARE") => {
      setDisplayedPage(pageCode);
    }

    if (loading) {
      return <LoaderModal hasMessage={false}/>;
    } 

    return (
      <div className="entreprise-container">
        {/* {
          !isMobile() &&  */}
          <h1 className="title ml-lg-desktop mb-sm fw-medium">{displayedPage === "INFO" || displayedPage === "INFO_TABLE" ? "Le dispositif de minoration de cotisations" : "Souhaitez-vous renforcer votre couverture ?"}</h1>
        {/* } */}
        <div ref={pageGapRef} className="page-gap" />
       
        <div className={"page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop"}>
          <REGuarantyRetirementBloc 
            handleSwitchPage={handleSwitchPage} 
            garanties={garanties} 
            displayedPage={displayedPage} 
          />
        </div>
      </div>
    )

}